<script lang="ts">
export default {
  name: 'KkReviewImages',
}
</script>
<script setup lang="ts">
import { ref, computed } from 'vue'
import { KkImageModal } from '../../../review'

type Props = {
  images: Image[]
  siteType: string
  siteName: string
  storeName: string
  postedAt: string
  hideReportLink: boolean
}
type Image = {
  url: string
  report_url?: string
}
const props = withDefaults(defineProps<Props>(), {
  images: () => [],
  siteType: '',
  siteName: '',
  storeName: '',
  postedAt: '',
  hideReportLink: false,
})

const isExpanded = ref<boolean>(false)
const showImageModal = ref<boolean>(false)
const selectedPhotoIndex = ref<number | null>(null)

const displayedImages = computed<Image[]>(() => {
  return isExpanded.value ? props.images : props.images.slice(0, 4)
})
const additionalImagesCount = computed<number>(() => {
  return props.images.length - 4
})
const expandImages = (): void => {
  isExpanded.value = !isExpanded.value
}
const openImageModal = (index: number): void => {
  showImageModal.value = true
  selectedPhotoIndex.value = index
}
const closeImageModal = (): void => {
  showImageModal.value = false
  selectedPhotoIndex.value = null
}
</script>
<template>
  <div class="reviewImage">
    <div v-for="(displayedImage, i) of displayedImages" :key="`displayImage_${i}`" class="imageWrapper">
      <img :src="displayedImage.url" alt="" @click="openImageModal(i)">
      <div v-if="i === 3 && !isExpanded && additionalImagesCount > 0" class="overlay" @click="expandImages">
        {{ additionalImagesCount }}+
      </div>
    </div>
    <KkImageModal
      v-if="showImageModal"
      :images="props.images"
      :site-name="props.siteName"
      :store-name="props.storeName"
      :site-type="props.siteType"
      :posted-at="props.postedAt"
      :hide-report-link="props.hideReportLink"
      :selected-photo-index="selectedPhotoIndex"
      @closeImageModal="closeImageModal"
    />
  </div>
</template>
<style lang="scss" scoped>
@import '../../../../../../stylesheets/biz_spa/foundation/_var.scss';
.reviewImage {
  gap: 10px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);

  .imageWrapper {
    position: relative;
    width: 100%;
    aspect-ratio: 1 / 1;

    img, .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 4px;
    }

    img {
      width: 100%;
      aspect-ratio: 1 / 1;
      object-fit: cover;
    }

    .overlay {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(0, 0, 0, 0.5);
      color: white;
      font-size: 24px;
      cursor: pointer;
      font-weight: bold;
    }
  }
}
</style>
